import { Box, Row, Txt } from "@stenajs-webui/core";
import {
  Cardy,
  CardyBody,
  FlatButton,
  Icon,
  stenaMobile,
  stenaSailingVehicle,
} from "@stenajs-webui/elements";
import type { FC } from "react";

import { FreightPortalPopover } from "../../../../common-ui/popover/FreightPortalPopover";
import { CopyBookingLinkButton } from "../../share/components/CopyBookingLinkButton";
import { ShareBookingPanel } from "../../share/components/ShareBookingPanel";

export interface ShareBookingProps {
  bookingNo: number;
  vehicleRegNo: string;
}

export const ShareBookingCard: FC<ShareBookingProps> = ({
  bookingNo,
  vehicleRegNo,
}) => {
  return (
    <>
      <Cardy color={"--lhds-color-blue-50"}>
        <CardyBody gap={2}>
          <Row gap={2}>
            <Icon icon={stenaSailingVehicle} size={24} />
            <Box width={200} flexGrow={1}>
              <Txt size={"small"}>
                Send this booking directly to the Driver app or copy the link
                and share via WhatsApp, email, etc.
              </Txt>
            </Box>
          </Row>
          <CopyBookingLinkButton
            trackerCategory={"Details"}
            bookingNo={bookingNo}
            vehicleRegNo={vehicleRegNo}
          />
          <FreightPortalPopover
            placement={"bottom-end"}
            renderTrigger={(props) => (
              <FlatButton
                leftIcon={stenaMobile}
                label={"Send to Driver app"}
                {...props}
              />
            )}
          >
            {({ onRequestClose }) => (
              <ShareBookingPanel
                onClose={onRequestClose}
                bookingNo={bookingNo}
                vehicleRegNo={vehicleRegNo}
                trackerCategory={"Details"}
                showCopyBookingLink={false}
              />
            )}
          </FreightPortalPopover>
        </CardyBody>
      </Cardy>
    </>
  );
};
